import { jsxs, jsx } from "react/jsx-runtime";
const IconGroupChatSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 37 21",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M29.404 9.412c1.902 0 3.443-1.58 3.443-3.53 0-1.949-1.541-3.529-3.443-3.529-1.902 0-3.443 1.58-3.443 3.53 0 1.949 1.541 3.529 3.443 3.529Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.29 17.647c0-3.898-3.083-7.059-6.886-7.059s-6.887 3.16-6.887 7.06h13.774Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M7.596 9.412c1.902 0 3.444-1.58 3.444-3.53 0-1.949-1.542-3.529-3.444-3.529-1.901 0-3.443 1.58-3.443 3.53 0 1.949 1.542 3.529 3.443 3.529Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.483 17.647c0-3.898-3.084-7.059-6.887-7.059-3.803 0-6.887 3.16-6.887 7.06h13.774Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M18.5 8.235c2.219 0 4.017-1.843 4.017-4.117S20.72 0 18.5 0c-2.219 0-4.017 1.844-4.017 4.118S16.28 8.235 18.5 8.235Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.256 20c0-5.198-4.368-9.412-9.756-9.412S8.744 14.802 8.744 20h19.512Z"
        }
      )
    ]
  }
);
export {
  IconGroupChatSvg
};
